/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Grid, Typography } from '@mui/material';
import React from 'react';
import type { InfoDialogThemesAndKeywordsProps } from '../../store/types';
import { useDataExplorerTranslation } from '../../utils/i18n';

const InfoDialogKeywords: React.FC<InfoDialogThemesAndKeywordsProps> = ({
  themes,
  keywords,
}: InfoDialogThemesAndKeywordsProps) => {
  const { t } = useDataExplorerTranslation();
  // Returns all theme words
  const getAllThemeIds = (
    themes: { concepts: { id: string }[] }[],
  ): string[] => {
    return themes.flatMap((theme) =>
      theme.concepts.map((concept) => concept.id),
    );
  };

  return (
    <Grid container direction="column" spacing={2}>
      {!!themes && (
        <Grid container direction="column" spacing={0}>
          <Grid>
            <Typography color="textSecondary" variant="caption">
              {t('themes-and-keywords-themes')}
            </Typography>
          </Grid>
          <Grid container>
            <Typography>{getAllThemeIds(themes).join(', ')}</Typography>
          </Grid>
        </Grid>
      )}
      {!!keywords && (
        <Grid container direction="column" spacing={0}>
          <Grid>
            <Typography color="textSecondary" variant="caption">
              {t('themes-and-keywords-keywords')}
            </Typography>
          </Grid>
          <Grid container>
            <Typography>{keywords.join(', ')}</Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default InfoDialogKeywords;
